import { render, staticRenderFns } from "./TalkAbout.vue?vue&type=template&id=929cabd0&scoped=true&"
import script from "./TalkAbout.vue?vue&type=script&lang=js&"
export * from "./TalkAbout.vue?vue&type=script&lang=js&"
import style0 from "./TalkAbout.vue?vue&type=style&index=0&id=929cabd0&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "929cabd0",
  null
  
)

export default component.exports